import React, { useState } from 'react';
import { format } from 'date-fns';
import { useAuth } from '../App';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

const DURATIONS = [30, 60, 90, 120, 180, 240, 300, 360, 480];

export const TrainerBlockForm = ({ slot, trainerId, onDone, onCancel }) => {
  const { language, API } = useAuth();
  const L = (en, de) => (language === 'de' ? de : en);
  const [duration, setDuration] = useState(60);
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!notes.trim()) { toast.error(L('Please enter a reason', 'Bitte einen Grund eingeben')); return; }
    setSaving(true);
    try {
      await API.post('/trainer/blocks', {
        trainer_id: trainerId, date: format(slot.date, 'yyyy-MM-dd'),
        start_time: slot.time, duration_minutes: duration, notes: notes.trim(),
      });
      toast.success(L('Time blocked', 'Zeit blockiert'));
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || L('Could not block', 'Blockieren fehlgeschlagen'));
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-4 mt-4" data-testid="trainer-block-form">
      <p className="text-xs text-slate-500">{L('Blocks only the trainer — no court is reserved.', 'Blockiert nur den Trainer — es wird kein Platz reserviert.')}</p>
      <div className="space-y-2">
        <Label className="label-text">{L('Duration', 'Dauer')}</Label>
        <div className="grid grid-cols-3 gap-2">
          {DURATIONS.map((d) => (
            <button key={d} type="button" onClick={() => setDuration(d)} data-testid={`block-duration-${d}`}
              className={`px-2 py-2 rounded-lg text-sm font-semibold border transition-colors ${duration === d ? 'bg-slate-700 text-white border-slate-700' : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50'}`}>
              {d < 60 ? `${d} min` : `${d / 60} h`}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <Label className="label-text">{L('Reason / note', 'Grund / Notiz')}</Label>
        <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3}
          placeholder={L('e.g. external meeting', 'z.B. Meeting extern')} data-testid="block-notes-input" />
      </div>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onCancel} className="flex-1">{L('Cancel', 'Abbrechen')}</Button>
        <Button onClick={save} disabled={saving} className="flex-1 bg-slate-700 hover:bg-slate-800 text-white font-bold" data-testid="block-save-btn">
          {saving ? '…' : L('Block time', 'Zeit blockieren')}
        </Button>
      </div>
    </div>
  );
};
